











import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import InfoDialog from "../InfoDialog.vue";

@Component({
    components: {
        "at-info-dialog": InfoDialog,
    }
})
export default class RequireRegcodeInfoDialog extends CommonBase {
    @Prop({default: false})
    value!: boolean;

    get show() {
        return this.value;
    }
    set show(v: boolean) {
        this.$emit("input", v);
    }
}
